/* Libellés et couleurs des statuts de mission (location-service), en un seul
   endroit pour l'accueil, la liste et la fiche. Une valeur inconnue n'est
   jamais affichée brute. */
import { COULEURS } from '../theme/charte';

export interface StyleStatutMission { libelle: string; couleur: string }

/* Libellés des maquettes : en étude (gris), en collecte (bleu), livrée (vert).
   « Devis émis » (ocre) ne se lit pas dans le statut : voir statutClient
   (donnees/missions), qui le déduit des documents. */
const STATUTS: Record<string, StyleStatutMission> = {
  brouillon:             { libelle: 'En étude',    couleur: COULEURS.neutre },
  en_attente_validation: { libelle: 'En étude',    couleur: COULEURS.neutre },
  publiee:               { libelle: 'En collecte', couleur: COULEURS.info },
  active:                { libelle: 'En collecte', couleur: COULEURS.info },
  terminee:              { libelle: 'Livrée',      couleur: COULEURS.succes },
  archivee:              { libelle: 'Archivée',    couleur: COULEURS.neutre },
};

export function styleStatutMission(statut?: string | null): StyleStatutMission {
  return (statut && STATUTS[statut]) || { libelle: 'Statut à préciser', couleur: COULEURS.neutre };
}
